import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "../../assets/svg/CloseIcon";
// import LogoIcon from "../../assets/svg/Logo";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    if (location.pathname !== "/") {
      e.preventDefault(); // Prevent default Link behavior
      navigate("/"); // Navigate to the landing page
    }
  };
  return (
    <Wrapper
      className="animate whiteBg"
      style={{ backgroundColor: "rgb(238, 107, 0)" }}
      sidebarOpen={sidebarOpen}
    >
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <img
            alt="Logo Valacademy Formations"
            src={require("../../assets/img/Logo/Logo02.png")}
            style={{ marginLeft: -10 }}
            width={70}
            height={70}
          />
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            Valacademy Formations
          </h1>
        </div>
        <CloseBtn
          aria-label="Menu"
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="animate pointer"
        >
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <a
            href="#home"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            onClick={(e) => {
              handleClick(e);

              e.preventDefault(); // Prevent default anchor jump
              toggleSidebar(!sidebarOpen); // Your existing sidebar toggle
              const section = document.getElementById("home");
              if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          >
            Accueil
          </a>
        </li>
        <li className="semiBold font15 pointer">
          <a
            href="#services"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            onClick={(e) => {
              handleClick(e);
              e.preventDefault();
              toggleSidebar(!sidebarOpen);
              const section = document.getElementById("services");
              if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          >
            Services
          </a>
        </li>

        <li className="semiBold font15 pointer">
          <a
            href="#aide-avis"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            onClick={(e) => {
              handleClick(e);

              e.preventDefault();
              toggleSidebar(!sidebarOpen);
              const section = document.getElementById("Aide & Avis");
              if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          >
            Aide & Avis
          </a>
        </li>

        <li className="semiBold font15 pointer">
          <a
            href="#contact"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            onClick={(e) => {
              handleClick(e);

              e.preventDefault();
              toggleSidebar(!sidebarOpen);
              const section = document.getElementById("contact");
              if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          >
            Contact
          </a>
        </li>

        {/* <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="pricing"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Pricing
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="contact"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Contact
          </Link>
        </li> */}
      </UlStyle>
      <UlStyle className="flexSpaceCenter">
        <li className="semiBold font15 pointer">
          <a
            href="/"
            style={{ padding: "10px 30px 10px 0" }}
            className="whiteColor"
          >
            Se connecter
          </a>
        </li>
        <li
          style={{ marginRight: -30 }}
          className="semiBold font15 pointer flexCenter"
        >
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
          >
            <img
              alt="Logo Valacademy Formations"
              src={require("../../assets/img/Logo/Logo02.png")}
              width={80}
              height={80}
            />
          </Link>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
